export default __webpack_public_path__ + "static/media/multitasking.d26d2918.svg";